import React from 'react';
import { styled } from 'linaria/react'
import { ReactComponent as PrebookIcon } from '../../../svg/Prebook.svg'
import { ReactComponent as OutOfStockIcon } from '../../../svg/OutOfStock.svg'
import { ReactComponent as InStockIcon } from '../../../svg/InStock.svg'
import { getPackageStockStatus, isArrayWithItems } from '../../Core/Util/Helpers';
import { useIntl } from '@jetshop/intl'
import { STOCK_ID } from '../../Core/Util/Constants';

const StockContainer = styled.div`
    .product-stock {
        font-size: var(--fontsize-075);
        font-weight: 600;
    }

    .product-stock svg {
        width: 24px;
        height: 24px;
    }
`
const WAREHOUSE_IN_STOCK_ID = 1
const WAREHOUSE_LOW_STOCK_ID = 2
const WAREHOUSE_OUT_OF_STOCK_ID = 3

const getWarehouseStockStatusId = (warehouseStockLevel) => {
   if (warehouseStockLevel >= 3 ) {
      return WAREHOUSE_IN_STOCK_ID
   } else if (warehouseStockLevel < 3 && warehouseStockLevel != 0 ) {
      return WAREHOUSE_LOW_STOCK_ID
   } else {
      return WAREHOUSE_OUT_OF_STOCK_ID
   }
}

const WarehouseStockInfo = ({ warehouseStockLevel }) => {

   // Generate a class name for SEO purposes based on the warehouseStockLevel.
   const seoStockStatusClassName = `boras-${getWarehouseStockStatusId(warehouseStockLevel)}`

   return (
      <span className={`${seoStockStatusClassName} product-stock d-flex align-items-center`}>
         {warehouseStockLevel >= 3 ? (
            <>
               <InStockIcon className="pr-8"></InStockIcon>
               {'Boråsbutiken'}
            </>
         ) : warehouseStockLevel < 3 && warehouseStockLevel != 0 ? (
            <>
               <PrebookIcon className="pr-8"></PrebookIcon>
               {'Boråsbutiken'}
            </>
         ) : (
            <>
               <OutOfStockIcon className="pr-8"></OutOfStockIcon>
               {'Boråsbutiken'}
            </>
         )}
      </span>
   )
}

const ProductStockStatus = ({activeVariant, includeWarehouse, packageProducts}) => {
   const t = useIntl()
   const {stockStatus, warehouseStock} = activeVariant

   const isMainVariantPackage = activeVariant?.isPackage === true
   const isPackageItems = isMainVariantPackage && isArrayWithItems(packageProducts)

   const packageStatusInfo =
      isPackageItems && activeVariant?.stockStatus?.buyable === true
         ? getPackageStockStatus(packageProducts)
         : {stockStatusId: STOCK_ID.OUT_OF_STOCK, text: t('stock status out of stock') } // Out of stock
         
    const stockStatusId = isMainVariantPackage ? packageStatusInfo?.stockStatusId : stockStatus?.stockStatusId

    // If isMainVariantPackage, use the constructed packageStatusInfoText
    const text = isMainVariantPackage ? packageStatusInfo?.text : stockStatus?.text;

    const warehouseStockLevel = warehouseStock?.length > 0 ? warehouseStock[0]?.stockLevel : 0;

    // Generate a class name for SEO purposes based on the stock status ID.
    const seoStockStatusClassName = `online-${stockStatusId}`

    return (
       <StockContainer className="my-8">
          <span className="product-stock d-flex align-items-center gap-3">
             <div>
                <span className={`${seoStockStatusClassName} product-stock d-flex align-items-center`}>
                   {(() => {
                      if(STOCK_ID.IN_STOCK.includes(stockStatusId)){
                        return (
                           <>
                              <InStockIcon className="pr-8"></InStockIcon>
                              {text}{' '}
                           </>
                        )
                      }else if(STOCK_ID.PREBOOK.includes(stockStatusId)){
                        return (
                           <>
                              <PrebookIcon className="pr-8"></PrebookIcon>
                              {text}{' '}
                           </>
                        )

                      }else{
                        return (
                           <>
                              <OutOfStockIcon className="pr-8"></OutOfStockIcon>
                              {text}{' '}
                           </>
                        )
                      }
                   })()}
                </span>
             </div>
             <div>
                {includeWarehouse && !isMainVariantPackage && <WarehouseStockInfo warehouseStockLevel={warehouseStockLevel}></WarehouseStockInfo>}
             </div>
          </span>
       </StockContainer>
    )
}
 
export default ProductStockStatus;